<template>
  <div>
    <Form
      ref="editModel"
      :model="editModel"
      :rules="ruleValidate"
      :label-width="100"
    >
      <FormItem label="版本名称" prop="VersionName">
        <Input v-model="editModel.VersionName" placeholder="版本名称"></Input>
      </FormItem>
      <FormItem label="版本号" prop="VersionCode">
        <Input v-model="editModel.VersionCode"></Input>
      </FormItem>

      <FormItem label="服务" prop="ClientSN">
        <!-- <dicTree @selectTreeData="selectdicTreeData"></dicTree> -->
        <Button type="primary" @click="dictreeModel = true">选择服务</Button>
        <span class="ml-5">{{ editModel.DicName }}</span>
      </FormItem>
      <FormItem label="更新设备" prop="ClientSN">
        <Button type="primary" @click="selectClient">选择设备</Button>
        <span class="ml-5 limitshow">{{ editModel.ClientName }}</span>
      </FormItem>
      <FormItem label="是否强制更新">
        <i-switch v-model="editModel.ForceUpdate" size="large">
          <span slot="open">是</span>
          <span slot="close">否</span>
        </i-switch>
      </FormItem>
      <FormItem label="备注">
        <Input
          v-model="editModel.Remark"
          type="textarea"
          :autosize="{ minRows: 2, maxRows: 5 }"
        ></Input>
      </FormItem>
    </Form>
    <Upload
      ref="uploadFile"
      :action="uploadUrl"
      :headers="headers"
      :on-success="uploadSuccess"
      :on-error="uploadError"
    >
      <!-- :show-upload-list="false" -->
      <Button icon="ios-cloud-upload-outline">选择压缩包</Button>
    </Upload>
    <div>{{ fileName }}</div>
    <div class="text-center modal-foter">
      <Button @click="returnBack" class="mr-5">取 消</Button>
      <Button type="success" @click="handleSubmit('editModel')"
        >确 定</Button
      >
    </div>
    <Modal
      v-model="dictreeModel"
      title="选择服务"
      @on-ok="okdicModal"
      @on-cancel="canceldicModal"
    >
      <dicTree   v-if="dictreeModel" @selectTreeData="selectdicTreeData"   :currentData="editModel.DicId"></dicTree>
    </Modal>
    <Modal
      v-model="clienttreeModel"
      title="选择客户端"
      @on-ok="okclientModal"
      @on-cancel="cancelclientModal"
    
    >
      <clientTree  v-if="clienttreeModel" @selectTreeData="selectClientTreeData"   :currentData="editModel.ClientSNs"></clientTree>
    </Modal>
  </div>
</template>
<script>
import dicTree from "./selectDic.vue";
import clientTree from "./selectClient.vue";
import organTree from "../../basedata/organ/organTree.vue";
import token from "../../../utils/token.js";
export default {
  components: { organTree, dicTree, clientTree },
  props: ["currentData"],
  data: function () {
    return {
      treeModel: false,
      dictreeModel: false,
      clienttreeModel: false,
      organParentName: "",
      DicIdtemp: "",
      DicNametemp: "",
      ClientNametemp: "",
      ClientSNtemp: [],
  
      fileName: "",
      headers: "",
      uploadUrl: "",
      editModel: {
        ID: "",
        VersionName: "",
        VersionCode: 0,
        Remark: "",
        ClientSNs: [],
        ClientName: "",
        ForceUpdate: true,
        DicId: "",
        DicName: "",
        UpdateFilePath: "",
      },
      SecretTypeSelect: [],
      ruleValidate: {
        VersionName: [
          {
            required: true,
            message: "不能为空",
          },
        ],
        VersionCode: [
          {
            required: true,
            message: "不能为空",
          },
        ],
        DicName: [
          {
            required: true,
            message: "不能为空",
          },
        ],
        UpdateFilePath: [
          {
            required: true,
            message: "不能为空",
          },
        ],
      },
    };
  },

  created: function () {
    console.log('edit  create');
    this.SecretTypeSelect = this.$common.getJsonData("clientType");
    let baseUrl = localStorage.getItem("baseURL");
    this.uploadUrl = baseUrl + "/clientversion/uploadrar";
    this.headers = { Authorization: "Bearer " + token.getToken() };
    var current = this;
    this.$api
      .post("clientVersion/get?id=" + this.currentData.id)
      .then((rsp) => {
        current.editModel.ID = rsp.data.id;
        current.editModel.VersionName = rsp.data.versionName;
        current.editModel.VersionCode = rsp.data.versionCode;
        current.editModel.Remark = rsp.data.remark;
        current.editModel.ClientSNs = rsp.data.clientSNs;
        current.editModel.ClientName = rsp.data.clientName;
        current.editModel.ForceUpdate = rsp.data.forceUpdate;
        current.editModel.DicId = rsp.data.dicId;
        current.editModel.DicName = rsp.data.dicName;
        current.editModel.UpdateFilePath = rsp.data.updateFilePath;

        if (
          current.editModel.UpdateFilePath &&
          current.editModel.UpdateFilePath.indexOf("/") >= 0
        ) {
          current.fileName = current.editModel.UpdateFilePath.substr(
            current.editModel.UpdateFilePath.lastIndexOf("/") + 1
          );
          console.log(current.fileName);
        }
      });
  },

  methods: {
    returnBack: function () {
      this.$emit("close");
    },
    selectClient() {
      console.log("ClientSN:" + this.editModel.ClientSNs);
      // this.initClientSN = this.editModel.ClientSNs;
      this.clienttreeModel = true;
    },
    handleSubmit: function (from) {
      this.$refs[from].validate((valid) => {
        if (valid) {
          this.$api.post("clientVersion/update", this.editModel).then((rsp) => {
            if (rsp != false) {
              this.$Message.success("更新成功");
              this.returnBack();
              this.resetData();
              this.$emit("loadData");
            }
          });
        }
      });
    },

    resetData() {
      for (let key in this.editModel) {
        this.editModel[key] = "";
      }
      this.$refs["editModel"].resetFields();
    },
    selectTreeData: function (data) {
      //  this.DicIdtemp= data[0].organID;
      //   this.editModel.organName = data[0].title;
    },
    selectdicTreeData: function (data) {
      if (data && data.length > 0) {
        if (data[0].isroot) {
          alert("请选择子节点");
          return;
        }
        this.DicIdtemp = data[0].id;
        this.DicNametemp = data[0].title;
      }
    },
    okdicModal() {
      this.editModel.DicId = this.DicIdtemp;
      this.editModel.DicName = this.DicNametemp;
    },
    canceldicModal() {},

    selectClientTreeData: function (data) {
      console.log(`selected item:${JSON.stringify(data)}`);

      let showclient = [];
      let showclientSN = [];

      data.forEach(function (item, idnex) {
        if (!item.isroot) {
          showclient.push(item.title);
          showclientSN.push(item.id);
        }
      });
      this.ClientSNtemp = showclientSN;
      this.ClientNametemp = showclient.join(",");
    },
    okclientModal() {
      this.editModel.ClientSNs = this.ClientSNtemp;
      this.editModel.ClientName = this.ClientNametemp;
    },
    cancelclientModal() {},
    //导入
    uploadSuccess: function (response, file, fileList) {
      if (response.statusCode == 200) {
        this.$Message.success("上传成功");
        this.editModel.UpdateFilePath = response.data;
        this.fileName = "";
      } else {
        this.$Message.success(response.msg);
      }
    },

    cancel: function () {},
    uploadError: function (error, file, fileList) {
      this.$Message.success("上传失败");
    },
  },
};
</script>
<style scoped>
.limitshow {
  max-width: 10em;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
</style>